import { tabsClasses } from '@mui/material';
import { CSSObject, Theme } from '@mui/material/styles';

// A bit smaller than GLOBAL_TABS_HEIGHT.
export const GLOBAL_TABS_INNER_HEIGHT = '2.125rem';

export const getTabScrollStyles = (theme: Theme): CSSObject => {
  const { sys } = theme.palette.custom.OV;

  return {
    [`& .${tabsClasses.scroller}`]: {
      scrollbarWidth: 'none',
    },
    [`& .${tabsClasses.scroller}::-webkit-scrollbar`]: {
      display: 'none',
    },
    [`& .${tabsClasses.scrollButtons}`]: {
      width: GLOBAL_TABS_INNER_HEIGHT,
      height: GLOBAL_TABS_INNER_HEIGHT,
      flexShrink: 0,
      alignSelf: 'center',
      marginInline: '0.125rem',
      borderRadius: '0.5rem',
      border: `1px solid ${sys.outlineVariant}`,
      backgroundColor: sys.surfaceContainerLow,
      color: sys.onSurface,
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'color'], {
        duration: 180,
      }),
      '&:hover': {
        backgroundColor: sys.surfaceContainer,
      },
      '&.Mui-disabled': {
        opacity: 1,
        color: sys.outline,
      },
    },
  };
};
